module.exports = __webpack_public_path__ + "assets/images/couch-02.09eb02900408b4f3fe7437a0ad59e643.svg";